import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  data: [],
};

export const consultantStatusSlice = createSlice({
  name: "status",
  initialState,
  reducers: {
    setConsultantStatus: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    updateSingleConsultantStatus: (state, action) => {
      const { _id, onlineStatus, preserveBusy, readyForAudio, readyForVideo } =
        action.payload;
      const index = state.data.findIndex((item) => String(item?._id) === String(_id));
      const extra = {};
      if (typeof readyForAudio === "boolean") extra.readyForAudio = readyForAudio;
      if (typeof readyForVideo === "boolean") extra.readyForVideo = readyForVideo;
      if (index !== -1) {
        // Presence pings send online:true while a call is live. Do not
        // clobber "busy" unless this update is an explicit busy/offline change.
        if (
          preserveBusy &&
          state.data[index]?.onlineStatus === "busy" &&
          onlineStatus === "online"
        ) {
          state.data[index] = { ...state.data[index], ...extra };
          return;
        }
        state.data[index] = {
          ...state.data[index],
          ...(onlineStatus ? { onlineStatus } : {}),
          ...extra,
        };
      } else {
        state.data.push({ _id, onlineStatus, ...extra });
      }
    },
  },
});

export const { setConsultantStatus, updateSingleConsultantStatus } = consultantStatusSlice.actions;
export default consultantStatusSlice.reducer;
